module.exports = __webpack_public_path__ + "static/3-brainly-design-system-watch-your-competition-dbaf8ecf740a447fa3c88f5ddf808cfe.png";